import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import Label from "../../../components/Common/Label";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from "../../../components/Common/Notification";
import SearchBar from "../../../components/Common/Searchbar";
import Table from "../../../components/Common/Table";
import TablePageControl from "../../../components/Common/TablePageControl";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import CustomSelect2 from "../../../components/Form/CustomSelect2";
import Helpers from "../../../helpers/helpers";
import { deletePayment, getPaymentListing, resetPaymentState } from "../../../store/actions";
import "../setting.css";
import RenderPopOverButton from "../../../components/Form/RenderPopOverButton.js";
import DeleteModal from "../../../components/Common/DeleteModal.js";


const ProductPaymentSetting = ({ title, paymentListing, userPermission, deletePaymentMethod }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [loading, setIsLoading] = useState(false);
    const [creatable, setCreateable] = useState(false);
    const [filterStatus, setFilterStatus] = useState('all');
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc")
    const [sort_by, setSortBy] = useState("id")
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [selectedRow, setSelectedRow] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const searchRef = useRef(keyword);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
            userPermission?.includes("create-setting") && setCreateable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        dispatch(resetPaymentState());
    }, []);

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    useEffect(() => {
        initData();
    }, [page, length, sort, sort_by, filterStatus]);

    useEffect(() => {
        if (deletePaymentMethod?.code === "success") {
            setDeleteOpen(false);
            setNotification({ open: true, msg: "Payment method deleted successfully", type: "success" });
            dispatch(resetPaymentState());
            setPage('1');
            initData();
        }
        setIsLoading(false);
    }, [deletePaymentMethod])

    const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

    const header = [
        {
            Header: "Type",
            columnID: "type",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div style={{ paddingRight: "5px" }}>{capitalizeFirstLetter(cellProps.type || '-')}</div>
                    </React.Fragment>
                );
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Description",
            columnID: "name",
            accessor: "name",
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Currency code",
            columnID: "currency_code",
            accessor: "currency_code",
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (<React.Fragment><Label.StatusLabel label={cellProps?.status === 1 ? 'active' : 'inactive'} marginLeft={'0px'} /></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {editable && <Link to={`/settings-edit-payment-method/` + (cellProps.id)} style={{ marginRight: 5 }}>
                            <CustomIconButton
                                iconName={'ri-pencil-line'}
                                onClick={() => ''}
                            />
                        </Link>}
                        <RenderPopOverButton
                            items={[{
                                iconName: 'ri-delete-bin-line',
                                label: 'Delete',
                                color: '#ED1A3D',
                                permission: deletable,
                                onClick: () => { setSelectedRow(cellProps); setDeleteOpen(true) }
                            }]}
                        />
                    </React.Fragment>
                )
            },
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    const initData = () => {
        let payload = {
            paginate: page,
            sort_order: sort,
            size: length,
            search: searchRef.current,
            sort: sort_by,
            filterStatus: filterStatus === 'all' ? '' : filterStatus
        }
        dispatch(getPaymentListing(payload))
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const resetFilter = () => {
        setPage("1");
        setSearch('');
        setFilterStatus(filterStatus === '' ? 'all' : '');
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item xs={12} className="d-flex align-items-center" spacing={1}>
                    <Grid item lg={3} md={3} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={filterStatus || "all"}
                            onChange={(e) => { setPage("1"); setFilterStatus(e) }}
                            data={Helpers.status}
                            placeholder={"All statuses"}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                    <div className="d-flex align-items-center">



                    </div>
                </Grid>
            </Grid>
        )
    }

    const handleDelete = () => {
        if (selectedRow?.id) {
            setIsLoading(true);
            dispatch(deletePayment({ id: selectedRow.id }));
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !paymentListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        title={title}
                        backRoute={'/settings'}
                        breadcrumbItems={[{ title: "Settings", link: "/settings" },
                        { title: title, link: "#" },
                        ]}
                        children={
                            creatable &&
                            <CustomButton
                                title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add Payment Method </>}
                                borderStyle={'1px solid #101010'}
                                backgroundColor={'#101010'}
                                textColor={'white'}
                                press={() => navigate("/settings-add-payment-method")}
                            />
                        }
                    >
                    </Breadcrumb>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={paymentListing?.data || []}
                        pageSize={length}
                        totalPage={paymentListing?.data?.length}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={paymentListing?.last_page || 1}
                    />
                    <DeleteModal
                        open={deleteOpen}
                        close={() => setDeleteOpen(false)}
                        submit={() => handleDelete()}
                        module={'payment method'}
                    />
                </Container>
            </div>
        </React.Fragment >
    );
};


function mapStateToProps({ Payment, Login }) {
    return {
        paymentListing: Payment.paymentListing?.data,
        userPermission: Login.permissionArry,
        deletePaymentMethod: Payment.deletePayment

    };
}

export default connect(mapStateToProps)(ProductPaymentSetting);